module.exports = __webpack_public_path__ + "static/media/fhs-earn-inactive.919a564f.png";